import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const BasicSelect = props => {
  const { t } = useTranslation();

  const {
    touched,
    errors,
    handleBlur,
    values,
    name,
    label,
    help,
    options,
    placeholder,
    none,
    noFormGroup,
    ajaxErrors,
    disabled,
    multiple,
    handleChange,
    setFieldValue,
    onChange
  } = props;

  const change = e => {
    if (!multiple) {
      handleChange(e);
    } else {
      let result = [];
      const options = e.target && e.target.options;

      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          result.push(options[i].value || options[i].text);
        }
      }

      setFieldValue(name, result);
    }

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={
        (touched[name] && errors[name]) ||
        (ajaxErrors && !touched[name] && ajaxErrors[name])
          ? (noFormGroup ? "" : "form-group m-form__group ") + "has-danger"
          : noFormGroup
          ? ""
          : "form-group m-form__group "
      }
    >
      {label && <label htmlFor={name}>{t(label)}</label>}
      <select
        className="form-control m-input"
        name={name}
        id={name}
        onChange={change}
        onBlur={handleBlur}
        value={values[name] ? values[name] : ""}
        disabled={!!disabled}
        multiple={!!multiple}
      >
        {placeholder && (
          <option disabled value="">
            {t(placeholder)}
          </option>
        )}
        {none && <option value="">{none}</option>}
        {options.map((item, i) => (
          <option
            value={item.value}
            key={item.value}
            disabled={item.disabled || false}
          >
            {item.title}
          </option>
        ))}
      </select>
      {help && <span className="m-form__help">{t(help)}</span>}
      {touched[name] && errors[name] && (
        <div className="form-control-feedback">{t(errors[name])}</div>
      )}
    </div>
  );
};

BasicSelect.propTypes = {
  touched: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  values: PropTypes.any,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  onChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  options: PropTypes.array,
  none: PropTypes.string,
  noFormGroup: PropTypes.bool,
  disabled: PropTypes.bool,
  ajaxErrors: PropTypes.object,
  multiple: PropTypes.bool
};

export default BasicSelect;
